import { css } from 'styled-components'

const navStyles = css`
  top: 0;
  display: flex;
  align-items: center;
  height: ${({ theme }) => theme.navHeight};
  padding: 0 28px;
  background: #ffffff;
  box-shadow: ${({ theme }) => theme.boxShadow.cc};
`

export default navStyles



// WEBPACK FOOTER //
// ./src/styles/common/nav.js